var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Toolbar"},[_c('LayoutToolbar',{attrs:{"title":_vm.$t('dashboard.dataAnalysis.title')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }